// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SetPersonClientTypeButton: 'set-person-client-type-button',
	SetCorporationClientTypeButton: 'set-corporation-client-type-button',
	SetBuilderClientTypeButton: 'set-builder-client-type-button',
} as const;
